<template>
  <SrpModal :isVisible="props.isVisible" @update:isVisible="isVisible => emit('update:isVisible', isVisible)">
    <template #content>
      <VisitPlanEstimDateForm
        :creatorChosenDate="props.collab?.collabInput?.collaboration?.creatorChosenDate"
        :actualTimingDate="props.collab?.collabInput?.collaboration?.actualTiming"
        :estimDate="props.collab?.creatorInput?.visitPlanEstimatedDate"
        :estimNotes="props.collab?.creatorInput?.visitPlanEstimateNotes"
        @update:estimDate="newDate => (_visitPlanEstimatedDate = newDate)"
        @update:estimNotes="newNotes => (_visitPlanEstimateNotes = newNotes)"
      />
    </template>

    <template #footer="{ closeModal }">
      <SrpButton color="gray" fill="outlined" @click="closeModal">Cancel</SrpButton>

      <SrpButton :isDisabled="props.isSaveDisabled || !props.collab?.creatorInput?.visitPlanEstimatedDate" @click="save(closeModal)">
        <template v-if="props.isSaveDisabled" #icon><LoadingIcon :size="18" /></template>
        Save
      </SrpButton>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";

// Components
import SrpModal from "@components/ui/SrpModal.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import VisitPlanEstimDateForm from "@components/collabCreatorInput/VisitPlanEstimDateForm.vue";

// Types
import { CreatorCollab } from "@contracts/collab";
import LoadingIcon from "@components/ui/LoadingIcon.vue";

const props = withDefaults(
  defineProps<{
    isVisible: boolean;
    isSaveDisabled: boolean;
    collab: CreatorCollab | null;
  }>(),
  {
    isVisible: true,
    isSaveDisabled: false,
    collab: null,
  }
);

const emit = defineEmits<{
  (e: "update:isVisible", value: boolean): void;
  (e: "save", _visitPlanEstimatedDate: string, _visitPlanEstimateNotes: string | null): void;
}>();

// Local Plan estimation fields ===============================================
const _visitPlanEstimatedDate = ref<string>("");
const _visitPlanEstimateNotes = ref<string>("");

onMounted(() => {
  _visitPlanEstimatedDate.value = props.collab?.creatorInput?.visitPlanEstimatedDate;
  _visitPlanEstimateNotes.value = props.collab?.creatorInput?.visitPlanEstimateNotes;
});

// Save =======================================================================
function save(closeModalCallback: Function) {
  emit("save", _visitPlanEstimatedDate.value, _visitPlanEstimateNotes.value);
  closeModalCallback();
}
</script>

<style scoped lang="scss"></style>
